module.exports = __webpack_public_path__ + "static/media/aquafury-4.1bbbbdde.jpg";